import settings from "../../config/settings"
import {calculateDate, getDecimalValue} from "../../config/helpingFunctions";
const axios = require("axios");

export default class ProjectService {

getDeletedProjects = async ()=>{
    let token = localStorage.getItem('keycloak-token');
    const params = new URLSearchParams({
        user_id: localStorage.getItem('userId')!
    });
    const resp = await axios.get(
        settings.apiUrl + "deleted-project?" + params,
        {
            headers:{
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        },
    );

    return resp['data'];
}

updateDeletedProjects = async (data: any)=>{
    let token = localStorage.getItem('keycloak-token');

    const resp = await axios.put(
        settings.apiUrl + "deleted-project" , data,
        {
            headers:{
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }},
    );

    return resp['status'];
}
getDeviceDetails = async (offset: number, limit: number, startDate: number, endDate: number, did:string, filter: any): Promise<any> => {
    let token = localStorage.getItem('keycloak-token');
    const params = new URLSearchParams({
      start_time: startDate.toString(),
      end_time: endDate.toString(),
      did: did,
      offset: offset.toString(),
      limit: limit.toString(),
      filter: JSON.stringify(filter)
    });

    const resp = await axios.get(
      settings.apiUrl + "monitor?" + params,
      {
          headers:{
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + token
          }
      },
    );

    let response_arr:Array<any> = [];

    let frequence_X:any = null, frequence_Y:any = null, frequence_Z:any = null
    resp.data["data"].map((data: any) => {
       if( data['frequence_X'] != null){
            frequence_X = getDecimalValue(Number(data['frequence_X']).toFixed(1));
        }
        if( data['frequence_Y'] != null){
            frequence_Y = getDecimalValue(Number(data['frequence_Y']).toFixed(1))
        }
        if( data['frequence_Z'] != null){
            frequence_Z = getDecimalValue(Number(data['frequence_Z']))
        }
        const final_date = calculateDate(data["start_time"])
        let response = {
        data_id: data["data_id"],
        station_name: data["station"],
        station: data['did'],
        start_time: final_date,
        project: data['project'],
        vector_sum: getDecimalValue(Number(data['vr']).toFixed(3)),
        max_X: getDecimalValue(Number(data['max_X']).toFixed(3)),
        max_Y: getDecimalValue(Number(data['max_Y']).toFixed(3)),
        max_Z:  getDecimalValue(Number(data['max_Z']).toFixed(3)),
        frequence_X: frequence_X,
        frequence_Y: frequence_Y,
        frequence_Z: frequence_Z,
        max: getDecimalValue(Number(data['main_max']).toFixed(3)),
        start_time_utc : data['start_time'],
        end_time_utc : data['end_time'],
        filename: data['filename'],
        filename_hash: data['filename_hash'],
        unit: data['unit'],
      };

      response_arr.push(response);
    });

    let response_json = {
      data: {
        response_arr,
      },
      totalRecords: resp.data["totalRecords"],
    };
    return response_json;
  };

getVisualizationData = async (did:string, startTime: any, endTime: any): Promise<any> => {
    let token = localStorage.getItem('keycloak-token');
    const params = new URLSearchParams({
        did: did,
        start_time: startTime.toString(),
        end_time: endTime.toString()
    })
    return await axios.get(settings.apiUrl + 'monitor/visualization?' + params,
     {
        headers:{
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    }
    ).then((resp: any) => resp.data);
}


getPointVisualizationData = async (did:string, startTime: any, endTime: any): Promise<any> => {
  let token = localStorage.getItem('keycloak-token');
  const params = new URLSearchParams({
      did: did,
      start_time: startTime.toString(),
      end_time: endTime.toString()
  })
  return await axios.get(settings.apiUrl + 'monitor/point-visualization?' + params,
   {
      headers:{
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
      }
  }
  ).then((resp: any) => resp.data);
}

getDinData = async (did:string, startTime: number, endTime: number): Promise<any> => {
  let token = localStorage.getItem('keycloak-token');
  const params = new URLSearchParams({
      did: did,
      start_time: startTime.toString(),
      end_time: endTime.toString()
  })

  return await axios.get(settings.apiUrl + 'monitor/visualization/din?' + params,
  {
      headers:{
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
      }
  }
  ).then((resp: any) => resp.data);
}

getFFTData = async  (did:string, startTime: number, endTime: number): Promise<any> => {
  let token = localStorage.getItem('keycloak-token');
  const params = new URLSearchParams({
    did: did,
    start_time: startTime.toString(),
    end_time: endTime.toString()
})

return await axios.get(settings.apiUrl + 'monitor/visualization/fft?' + params,
{
    headers:{
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
    }
}
).then((resp: any) => resp.data);
}

getVectorSumData = async  (did:string, startTime: number, endTime: number): Promise<any> => {
  let token = localStorage.getItem('keycloak-token');
  const params = new URLSearchParams({
    did: did,
    start_time: startTime.toString(),
    end_time: endTime.toString()
})

return await axios.get(settings.apiUrl + 'monitor/visualization/vector-sum?' + params,
{
    headers:{
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
    }
}
).then((resp: any) => resp.data);
}

getUserDetails = async (): Promise<any> => {
  let token: any = localStorage.getItem('keycloak-token');
  
  return await axios.get(settings.apiUrl + 'user/get-user',
{
    headers:{
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
    }
}
).then((resp: any) => resp.data);
}

getDeviceList =async (userId: any) => {
  let token = localStorage.getItem('keycloak-token');
    const params = new URLSearchParams({
        user_id: userId,
    })
  return await axios.get(settings.apiUrl + 'user/get-devices?' + params ,
{
    headers:{
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
    }
}
).then((resp: any) => resp.data);
}

getVisualizationFilter = async (did: string, id: string, search: string) => {
  let token = localStorage.getItem('keycloak-token');
  const params = new URLSearchParams({
    did: did,
    id: id,
    search: search
})
  return await axios.get(settings.apiUrl + 'monitor/find-next?' + params ,
  {
      headers:{
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
      }
  }
  ).then((resp: any) => resp.data);
  }

  getMultipleReport =async (did:string, startDate:any, endDate: any, projectId: string) => {
    let token = localStorage.getItem('keycloak-token');
    const params = new URLSearchParams({
      did: did,
      start_time: startDate,
      end_time: endDate,
      project_id: projectId
    })

    return await axios.get(settings.apiUrl + 'monitor/multiple-report?' + params ,
  {
      headers:{
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
      }
  }
  ).then((resp: any) => resp.data);
  }

  getSingleSeg2 =async (rowData:any) => {
    let token = localStorage.getItem('keycloak-token');
    const params = new URLSearchParams({
      filename: rowData["filename"],
      filename_hash: rowData["filename_hash"]
    })

    return await axios.get(settings.apiUrl + 'monitor/single-seg2?' + params,
  {
      headers:{
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
      }
  }
  ).then((resp: any) => resp.data);
  }

  getDeviceInfo =async (did:string, start_time: string, end_time:string) => {
    let token = localStorage.getItem('keycloak-token');
    const params = new URLSearchParams({
        did: did,
        start_time: start_time.toString(),
        end_time: end_time.toString()
    })
    return await axios.get(settings.apiUrl + 'monitor/device-info?' + params,
     {
        headers:{
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    }
    ).then((resp: any) => resp.data);
  }

  getMultipleSeg2 =async (did:string, startTime:any, endTime: any, apiType: string) => {
    let token = localStorage.getItem('keycloak-token');
    let email: any = localStorage.getItem('email') 
    const params = new URLSearchParams({
        did: did,
        start_time: startTime.toString(),
        end_time: endTime.toString(),
        email: email,
        apiType: apiType
    })
    return await axios.get(settings.apiUrl + 'monitor/multiple-seg2?' + params,
    {
      headers:{
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
      }
  }).then((resp: any) => resp);

  }



  getSlowTrace = async (did:string, startTime:any, endTime: any) => {
    let token = localStorage.getItem('keycloak-token');
    const params = new URLSearchParams({
        did: did,
        start_time: startTime.toString(),
        end_time: endTime.toString()
    })
    return await axios.get(settings.apiUrl + 'monitor/slow-trace?' + params,
     {
        headers:{
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    }
    ).then((resp: any) => resp.data);
  }

  getAssignedDevices = async (userId: any, station: any) => {
      let token = localStorage.getItem('keycloak-token');
      const params = new URLSearchParams({
          user_id: userId,
          station: station
      });

      const projects = await axios.get(settings.apiUrl + 'project?' + params, {
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + token
          }
      });

      const projectData = projects.data;

      await Promise.all(projectData.map(async (project: any) => {
          await Promise.all(project['project_devices'].map(async (device: any) => {
              const getStatus = await this.getDeviceStatus(device['did'], device['station']);
              if (getStatus) {
                  device['details'] = getStatus['details'];
                  device['timestamp'] = getStatus['timestamp'];
              } else {
                  // console.error(`Device status not found for device id: ${device['did']}, station: ${device['station']}`);
                  device['details'] = null;
                  device['timestamp'] = null;
              }
          }));
      }));

      return projectData;

  }

  getSingleAssignedDevice = async (projectId: any, userId:any, page: string) => {
    let token = localStorage.getItem('keycloak-token');
    const params = new URLSearchParams({
        project_id: projectId,
        user_id: userId,
        page: page
    });
    const projects = await axios.get(settings.apiUrl + 'project-home?' + params, {
          headers:{
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + token
          }
      });
    const projectData = projects.data;
    projectData['project_devices'].map(async (devices: any)=>{
        const getStatus = await this.getDeviceStatus(devices['did'], devices['station'])
        devices['details'] = getStatus['details'];
        devices['timestamp'] = getStatus['timestamp'];
    })


    return projectData;
  }

  getUnAssignedDevices = async (userId: any) => {
    let token = localStorage.getItem('keycloak-token');
    const params = new URLSearchParams({
        user_id: userId,
    })
    return await axios.get(settings.apiUrl + 'get-devices?' + params,
    {
       headers:{
           'Content-Type': 'application/json',
           'Authorization': 'Bearer ' + token
       }
   }
   ).then((resp: any) => resp.data);
  } 

  deleteProjectDevice =async (projectId:any, did: any, userId: any) => {
    let token = localStorage.getItem('keycloak-token');
    const params = new URLSearchParams({
        projectId: projectId,
        did: did,
        userId: userId
    })

    return await axios.delete(settings.apiUrl + 'project-device?' + params,
    {
       headers:{
           'Content-Type': 'application/json',
           'Authorization': 'Bearer ' + token
       }
   }
   ).then((resp: any) => resp.status);
  }

  getCoordinates =async (userId:any, projectId: any) => {
    let token = localStorage.getItem('keycloak-token');
    const params = new URLSearchParams({
        projectId: projectId,
        userId: userId
    })
    return await axios.get(settings.apiUrl + 'cordinates?' + params,
    {
       headers:{
           'Content-Type': 'application/json',
           'Authorization': 'Bearer ' + token
       }
   }
   ).then((resp: any) => resp.data);
  }

  assignProject = async (data: any)=>{
      let token = localStorage.getItem('keycloak-token');
      try {
          const response = await axios.post(settings.apiUrl + 'assign-project', data,
              {
                  headers: {
                      'Content-Type': 'application/json',
                      'Authorization': 'Bearer ' + token
                  }
              })

          return response
      }
      catch (err: any){
          if(err)
            return err['response']['data']
      }
  }

  downloadSlowTraceCSV = async (did: string, startTime: any, endTime: any)=>{
      let token = localStorage.getItem('keycloak-token');
      const params = new URLSearchParams({
          did: did,
          start_time: startTime,
          end_time: endTime
      })
      return await axios.get(settings.apiUrl + 'monitor/slow-trace-csv?' + params, {responseType: 'blob'},
          {
              headers:{
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ' + token
              }
          }
      ).then((resp: any) => resp.data);
  }

  getSlowTraceReport = async (did: string, startTime: string, endTime:string, projectId: string)=>{
      let token = localStorage.getItem('keycloak-token');
      const params = new URLSearchParams({
          did: did,
          start_time: startTime,
          end_time: endTime,
          project_id: projectId
      })

      return await axios.get(settings.apiUrl + 'monitor/slow-trace-report?' + params,
          {
              headers:{
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ' + token
              }
          }
      ).then((resp: any) => resp.data);
  }

  updateStationName = async (body: any) =>{
    let token = localStorage.getItem('keycloak-token');
    return await axios.put(settings.apiUrl + 'update-station', body,
          {
              headers:{
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ' + token
              }
          }
      ).then((resp: any) => resp);
  }

  getDeviceStatus = async (did: string, staionName: string)=>{
      let token = localStorage.getItem('keycloak-token');
      const params = new URLSearchParams({
          did: did,
          station_name: staionName
      })

      return await axios.get(settings.apiUrl + 'user/device-status?' + params,
          {
              headers:{
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ' + token
              }
          }
      ).then((resp: any) => resp.data);

  }

}


